import React from 'react';
import { LikeServices } from './Services';


enum LoadStatus {
    NotLoaded = 0,
    Loading = 1,
    Loaded = 2
}

const loadStatus: any = {
    userAddress: null,
    nftLikes: LoadStatus.NotLoaded,
    nftLikesCallback: null,
    collectionLikesCallback: null,
    collectionLikes: LoadStatus.NotLoaded
}

const useGetUserNFTLikes = (userAddress: string) => {

    const [likes, setLikes] = React.useState<{ collectionAddress: string, tokenID: string }[]>([]);
    const [isLoading, setIsLoading] = React.useState(false);

    React.useEffect(() => {
        if (!userAddress) return;
        setIsLoading(true);
        if (loadStatus.nftLikes === LoadStatus.NotLoaded || loadStatus.userAddress !== userAddress) {
            loadStatus.nftLikesCallback = new Promise((resolve) => {
                loadStatus.userAddress = userAddress;
                LikeServices.GetUserNFTLikes({ userAddress: userAddress.toLowerCase() }).then(res => {
                    resolve(res);
                    setLikes(res)
                    setIsLoading(false);
                    loadStatus.nftLikes = LoadStatus.Loaded;
                })
            })
            loadStatus.nftLikes = LoadStatus.Loading;
        } else {
            loadStatus.nftLikesCallback?.then((res: any) => {
                setLikes(res)
                setIsLoading(false);
                loadStatus.nftLikes = LoadStatus.Loaded;
            })
        }
    }, [userAddress]);

    const addToLiked = React.useCallback((contractAddress: string, tokenID: number) => {
        if (loadStatus.nftLikes === LoadStatus.Loaded) {
            setLikes([...likes, {
                collectionAddress: contractAddress,
                tokenID: tokenID.toString()
            }])
        }
    }, []);

    const removeFromLiked = React.useCallback((contractAddress: string, tokenID: number) => {
        if (loadStatus.nftLikes === LoadStatus.Loaded) {
            setLikes(likes.filter(like => like.collectionAddress !== contractAddress || like.tokenID !== tokenID.toString()))
        }
    }, []);

    return {
        likes,
        isLoading,
        addToLiked,
        removeFromLiked
    }

}

const useGetUserCollectionLikes = (userAddress: string) => {

    const [likes, setLikes] = React.useState<string[]>([]);
    const [isLoading, setIsLoading] = React.useState(false);

    React.useEffect(() => {
        if (!userAddress) return;
        setIsLoading(true);
        if (loadStatus.collectionLikes === LoadStatus.NotLoaded || loadStatus.userAddress !== userAddress) {
            loadStatus.collectionLikesCallback = new Promise((resolve) => {
                loadStatus.userAddress = userAddress;
                LikeServices.GetUserCollectionLikes({ userAddress: userAddress.toLowerCase() }).then(res => {
                    resolve(res);
                    setLikes(res)
                    setIsLoading(false);
                    loadStatus.collectionLikes = LoadStatus.Loaded;
                })
            })
            loadStatus.collectionLikes = LoadStatus.Loading;
        } else {
            loadStatus.collectionLikesCallback?.then((res: any) => {
                setLikes(res)
                setIsLoading(false);
                loadStatus.collectionLikes = LoadStatus.Loaded;
            })
        }
    }, [userAddress]);

    const addToLiked = React.useCallback((contractAddress: string) => {
        if (loadStatus.collectionLikes === LoadStatus.Loaded) {
            setLikes([...likes, contractAddress])
        }
    }, []);

    const removeFromLiked = React.useCallback((contractAddress: string) => {
        if (loadStatus.collectionLikes === LoadStatus.Loaded) {
            setLikes(likes.filter(like => like !== contractAddress))
        }
    }, []);

    return {
        likes,
        isLoading,
        addToLiked,
        removeFromLiked
    }

}

export { useGetUserNFTLikes, useGetUserCollectionLikes };